/** GRCh37 chromosome lengths in base pairs. */
export const CHROMOSOME_LENGTHS: Record<string, number> = {
  '1': 249250621,
  '2': 242193529,
  '3': 198295559,
  '4': 190214555,
  '5': 181538259,
  '6': 170805979,
  '7': 159345973,
  '8': 145138636,
  '9': 138394717,
  '10': 133797422,
  '11': 135086622,
  '12': 133275309,
  '13': 114364328,
  '14': 107043718,
  '15': 101991189,
  '16': 90338345,
  '17': 83257441,
  '18': 80373285,
  '19': 58617616,
  '20': 64444167,
  '21': 46709983,
  '22': 50818468,
  X: 156040895,
  Y: 57227415,
  MT: 16569,
};

export const TOTAL_GENOME_LENGTH = Object.values(CHROMOSOME_LENGTHS).reduce(
  (sum, length) => sum + length,
  0,
);

export const getChromosomeLength = (chromosome: string): number => {
  const chr = chromosome.replace('chr', '').toUpperCase();
  return CHROMOSOME_LENGTHS[chr] || 0;
};

export const calculateRelativePosition = (chromosome: string, position: number): number => {
  const chrLength = getChromosomeLength(chromosome);
  if (chrLength === 0) return 0;
  return position / chrLength;
};
